import { magicConfig, RoutablePage } from '@gig/magic-common';
import { USER_LOGOUT_KEYCLOAK, USER_LOGIN_KEYCLOAK, USER_PROFILE_DATA, UPDATE_USER_STATUS, UPDATE_DEPOSIT_RESTRICTION } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { mapToUser, fetchProfileData } from '../keycloak/keycloak.profile.js';
import { MobileAppSessionStatus, MobileAppMessageTypes } from './mobile-app.types.js';
import { decodeJwt } from './mobile-app.utils.js';

var MobileAppAuthService = /** @class */ (function () {
    function MobileAppAuthService(mobileAppService) {
        this.mobileAppService = mobileAppService;
        this.currentUserProfile = null;
    }
    MobileAppAuthService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var session, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.mobileAppService.checkSessionStatus()];
                    case 1:
                        session = _a.sent();
                        if (!(session.status === MobileAppSessionStatus.LOGGED_IN)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.createSession(session, false)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.destroySession()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.mobileAppService.onSessionMessage(this.handleSessionMessage.bind(this));
                        window.commandBus.subscribe(USER_LOGOUT_KEYCLOAK, function (_a) {
                            var payload = _a.payload;
                            _this.logout(payload);
                        });
                        window.commandBus.subscribe(USER_LOGIN_KEYCLOAK, function (_a) {
                            var payload = _a.payload;
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, this.login(payload === null || payload === void 0 ? void 0 : payload.url, payload === null || payload === void 0 ? void 0 : payload.params)];
                                        case 1:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        window.queryBus.subscribe(USER_PROFILE_DATA, function () {
                            return _this.currentUserProfile;
                        });
                        window.commandBus.subscribe(UPDATE_USER_STATUS, function () { return __awaiter(_this, void 0, void 0, function () {
                            var user, error_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this.fetchUserProfile()];
                                    case 1:
                                        user = _a.sent();
                                        magic.session.update(user);
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_2 = _a.sent();
                                        console.error('Failed to update user status:', error_2);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        window.eventBus.subscribe(UPDATE_DEPOSIT_RESTRICTION, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var user;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!event.payload) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.fetchUserProfile()];
                                    case 1:
                                        user = _a.sent();
                                        magic.session.update(user);
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        console.error('Failed to initialize mobile app session');
                        this.destroySession();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MobileAppAuthService.prototype.logout = function (redirectUri) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.pendingLogoutRedirect = redirectUri;
                this.mobileAppService.logout();
                return [2 /*return*/];
            });
        });
    };
    MobileAppAuthService.prototype.login = function (redirectUri, customParams) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.pendingLoginRedirect = redirectUri;
                        return [4 /*yield*/, this.mobileAppService.login(customParams)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MobileAppAuthService.prototype.handleSessionMessage = function (message) {
        switch (message.key) {
            case MobileAppMessageTypes.SESSION_CREATED:
                this.createSession(message.payload, false, true);
                break;
            case MobileAppMessageTypes.SESSION_UPDATED:
                this.updateSession(message.payload);
                break;
            case MobileAppMessageTypes.SESSION_DESTROYED:
                this.destroySession(true);
                break;
        }
    };
    MobileAppAuthService.prototype.createSession = function (session, connectWebsocket, doReload) {
        if (connectWebsocket === void 0) { connectWebsocket = true; }
        if (doReload === void 0) { doReload = false; }
        return __awaiter(this, void 0, void 0, function () {
            var idToken, user, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (session.status !== MobileAppSessionStatus.LOGGED_IN ||
                            !session.accessToken ||
                            !session.idToken) {
                            throw new Error('No session data provided');
                        }
                        idToken = decodeJwt(session.idToken);
                        magic.session.setSessionId(idToken.sid);
                        magic.session.setKeycloakSession({
                            token: session.accessToken,
                            refreshToken: session.refreshToken,
                            expiresAt: session.expiryDate,
                            idToken: session.idToken,
                        });
                        if (doReload) {
                            if (this.pendingLoginRedirect) {
                                window.location.href = this.pendingLoginRedirect;
                            }
                            else {
                                window.location.reload();
                            }
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.fetchUserProfile()];
                    case 1:
                        user = _a.sent();
                        magic.session.create(user);
                        if (!connectWebsocket) return [3 /*break*/, 3];
                        return [4 /*yield*/, magic.connectWsDriver()];
                    case 2:
                        _a.sent();
                        magic.methods.users.subscribeForTags(user);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        console.error('Error trying to create mobile app session', error_3);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MobileAppAuthService.prototype.updateSession = function (session) {
        return __awaiter(this, void 0, void 0, function () {
            var idToken;
            return __generator(this, function (_a) {
                try {
                    if (session.status !== MobileAppSessionStatus.LOGGED_IN ||
                        !session.accessToken ||
                        !session.idToken) {
                        throw new Error('No session data provided in update');
                    }
                    idToken = decodeJwt(session.idToken);
                    magic.session.invalidateAccessToken();
                    magic.session.setSessionId(idToken.sid);
                    magic.session.refreshKeycloakSession({
                        token: session.accessToken,
                        refreshToken: session.refreshToken,
                        expiresAt: session.expiryDate,
                        idToken: session.idToken,
                    });
                    magic.methods.users.subscribeForTags(magic.session.getUser());
                }
                catch (error) {
                    console.error('Error trying to Update mobile app session', error);
                }
                return [2 /*return*/];
            });
        });
    };
    MobileAppAuthService.prototype.destroySession = function (doReload) {
        if (doReload === void 0) { doReload = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                magic.session.destroy();
                this.currentUserProfile = null;
                if (doReload) {
                    if (this.pendingLogoutRedirect) {
                        window.location.href = this.pendingLogoutRedirect;
                    }
                    else {
                        window.location.href =
                            window.location.origin +
                                magicConfig.getRoute({ route: RoutablePage.HOME }).href;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    MobileAppAuthService.prototype.fetchUserProfile = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, profile, magicProfile, documents, idToken;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, fetchProfileData()];
                    case 1:
                        _b = _c.sent(), profile = _b.profile, magicProfile = _b.magicProfile, documents = _b.documents;
                        this.currentUserProfile = profile;
                        idToken = decodeJwt((_a = magic.session.getKeycloakSession()) === null || _a === void 0 ? void 0 : _a.idToken);
                        return [2 /*return*/, mapToUser(idToken.user_profile_id, idToken.email, idToken.sid, profile, magicProfile, documents)];
                }
            });
        });
    };
    return MobileAppAuthService;
}());

export { MobileAppAuthService };
